// eslint-disable-next-line import/no-extraneous-dependencies
import { CreateOrderRequestBody } from '@paypal/paypal-js/types/apis/orders';
import { PAYPAL_CLIENT_ID } from './index';

export const paypalOptions = {
  'client-id': PAYPAL_CLIENT_ID,
  currency: 'MXN',
  intent: 'capture',
  locale: 'es_MX',
};

export const createOrder = (
  plan: string,
  productId: string,
  customerId: string,
  amount: string
): CreateOrderRequestBody => {
  return {
    purchase_units: [
      {
        amount: {
          currency_code: 'MXN',
          value: amount,
        },
        description: `Plan ${plan}`,
        custom_id: `${productId}|${customerId}`,
      },
    ],
    application_context: {
      brand_name: 'TaxDown',
      shipping_preference: 'NO_SHIPPING',
      user_action: 'PAY_NOW',
    },
  };
};
